import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UsersService } from 'src/app/users/users.service';
import { StudiesService } from 'src/app/study/studies.service';
import { DomainsService } from 'src/app/shared/services/domains.service'; 
import { Subscription } from 'rxjs';
import { CommonService } from 'src/app/shared/services/common.service';
import { TranslateService } from '@ngx-translate/core';
import { SideMenuService } from 'src/app/shared/side-menu/side-menu.service';

@Component({
	selector: 'app-site-studies',
	templateUrl: './site-studies.component.html',
})

export class SiteStudiesComponent implements OnInit, OnDestroy {

	siteId: number = 0;
	customerId: number = 0;
	hasStudies: boolean = false;
	currentUser: any = {};
	isChargLinkDomain: boolean = false;
	siteSub: Subscription = new Subscription();
	currentSite: any = {};

	constructor(
		private route: ActivatedRoute,
		private router: Router,
		private usersService: UsersService,
		private studiesService: StudiesService,
		private domainsService: DomainsService,
		private commonService: CommonService,
		private translateService: TranslateService,
		private sideMenuService: SideMenuService
	){}

	ngOnInit() {
		this.currentUser = this.usersService.getCurrentUser();
		this.isChargLinkDomain = this.domainsService.isChargLink;

		if(!this.currentUser.has_access_to_any_study || this.isChargLinkDomain)
			return this.router.navigate(['/unauthorized']);

		this.siteId = this.route.parent.snapshot.params.siteId || 0;
		if(!this.siteId || isNaN(this.siteId))
			return this.router.navigateByUrl('/404');

		this.customerId = this.route.parent.snapshot.params.customerId || 0
		this.siteSub = this.sideMenuService.currentSite.subscribe((res) => {
		
			this.commonService.setPageTabTitle(`${res['customer_name']} - ${res['name']} - ${this.translateService.instant('studies.power_studies')}`);
			this.currentSite = res;
			if (this.currentUser.has_access_to_any_study)
				this.checkHasStudies();
		});
	}

	checkHasStudies() {
		this.studiesService.checkHasStudies(this.siteId).subscribe((res: any) => {
			this.hasStudies = res;
			if (!res)
				return this.router.navigateByUrl('/404');
		});
	}

	ngOnDestroy() {
		if (this.siteSub)
			this.siteSub.unsubscribe();
	}
}
